import {
  HTTP_GETFORECASTLIST1_FETCHING,
  HTTP_GETFORECASTLIST1_SUCCESS,
  HTTP_GETFORECASTLIST1_FAILED,
  HTTP_RESET_FORECASTLIST1,
  server,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";

export const setStateGetForecastToFetching1 = () => ({
  type: HTTP_GETFORECASTLIST1_FETCHING,
});

export const setStateGetForecastToSuccess1 = (payload) => ({
  type: HTTP_GETFORECASTLIST1_SUCCESS,
  payload,
});

export const setStateGetForecastToFailed1 = (payload) => ({
  type: HTTP_GETFORECASTLIST1_FAILED,
});

export const clearForecast1 = () => {
  return (dispatch) => {
    dispatch({ type: HTTP_RESET_FORECASTLIST1 });
  };
};
export const getForecast1 = (
  countryid,
  companyid,
  brandid,
  departmentid,
  yearcode,
  yearid
) => {
  return async (dispatch) => {
    dispatch(setStateGetForecastToFetching1());
    try {
      const result = await httpClient.get(
        `${server.GETFORECAST1_URL}/${countryid}/${companyid}/${brandid}/${departmentid}/${yearcode}/${yearid}`
      );

      dispatch(setStateGetForecastToSuccess1(result.data));

      return Promise.resolve(result.data.length);
    } catch (error) {
      dispatch(setStateGetForecastToFailed1());
      return Promise.reject(error.message);
    }
  };
};
